import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { OrganizationActions } from ".";
import {
  defaultCourse,
  defaultOrganization,
  defaultOrganizationState,
  defaultSessionInfo,
} from "./default";
import {
  CLEAR_MASTER_COURSE,
  CLEAR_MASTER_ORGANIZATION,
  CLEAR_MASTER_SESSION,
  CLEAR_MASTER_STATE,
  FETCH_COURSE_FAILED,
  FETCH_COURSE_PROGRESS,
  FETCH_COURSE_SUCCESS,
  FETCH_ORGANIZATIONS_FAILED,
  FETCH_ORGANIZATIONS_PROGRESS,
  FETCH_ORGANIZATIONS_SUCCESS,
  FETCH_SESSION_FAILED,
  FETCH_SESSION_LIST_FAILED,
  FETCH_SESSION_LIST_PROGRESS,
  FETCH_SESSION_LIST_SUCCESS,
  FETCH_SESSION_PROGRESS,
  FETCH_SESSION_SUCCESS,
} from "./organization.actions";
import { initialLead } from "../leads/leads.types";

export const organizationReducer = (
  state: IStoreState["masterOrganization"] = defaultOrganizationState,
  action: OrganizationActions
) => {
  switch (action.type) {
    case FETCH_ORGANIZATIONS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.organization.loading = LoadState.InProgress;
        draftState.organization.list = [];
        draftState.organization.data = defaultOrganization;
        draftState.organization.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_ORGANIZATIONS_SUCCESS: {
      const { data, totalRecords, singleOrganization } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.organization.loading = LoadState.Loaded;
        draftState.organization.list = data;
        draftState.organization.data = singleOrganization;
        draftState.organization.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_ORGANIZATIONS_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.organization.loading = LoadState.Failed;
        draftState.organization.list = [];
        draftState.organization.data = defaultOrganization;
        draftState.organization.totalRecords = 0;
        draftState.organization.error = action.payload.errorMessage;
      });
      return newState;
    }
    case FETCH_COURSE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.course.loading = LoadState.InProgress;
        draftState.course.list = [];
        draftState.course.totalRecords = 0;
        draftState.course.data = defaultCourse;
      });
      return newState;
    }
    case FETCH_COURSE_SUCCESS: {
      const { data, totalRecords, singleCourse } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.course.loading = LoadState.Loaded;
        draftState.course.list = data;
        draftState.course.data = singleCourse;
        draftState.course.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_COURSE_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.course.loading = LoadState.Failed;
        draftState.course.error = errorMessage;
      });
      return newState;
    }
    case FETCH_SESSION_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.session.loading = LoadState.InProgress;
        draftState.session.list = [];
        draftState.session.totalRecords = 0;
        
      });
      return newState;
    }
    case FETCH_SESSION_LIST_SUCCESS: {
      const { data,totalRecords  } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.session.loading = LoadState.Loaded;
        draftState.session.totalRecords = totalRecords;
        draftState.session.list = data;
       
      });
      return newState;
    }
    case FETCH_SESSION_LIST_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.session.loading = LoadState.Failed;
        draftState.session.error = errorMessage;
      });
      return newState;
    }
    case FETCH_SESSION_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.session.loading = LoadState.InProgress;
  
        draftState.session.totalRecords = 0;
        draftState.session.data = defaultSessionInfo;
      });
      return newState;
    }
    case FETCH_SESSION_SUCCESS: {
      const { data  } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.session.loading = LoadState.Loaded;
        
        draftState.session.data = data;
       
      });
      return newState;
    }
    case FETCH_SESSION_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.session.loading = LoadState.Failed;
        draftState.session.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_MASTER_ORGANIZATION: {
      const newState = produce(state, (draftState) => {
        draftState.organization.loading = LoadState.NotLoaded;
        draftState.organization.data = defaultOrganization;
      });
      return newState;
    }
    case CLEAR_MASTER_COURSE: {
      const newState = produce(state, (draftState) => {
        draftState.course.loading = LoadState.NotLoaded;
        draftState.course.data = defaultCourse;
      });
      return newState;
    }
    case CLEAR_MASTER_SESSION: {
      const newState = produce(state, (draftState) => {
        draftState.session.loading = LoadState.NotLoaded;
        draftState.session.data = defaultSessionInfo;
      });
      return newState;
    }
    case CLEAR_MASTER_STATE: {
      return defaultOrganizationState;
    }
    // case CLEAR_COURSE_LIST: {
    //   return defaultOrganizationState;
    // }

    default: {
      return state;
    }
  }
};
